import React from "react";
import {connect} from "react-redux";
import styled from "styled-components";

import {chatActions} from "_actions";
import {BubbleWrapper, MessageWrapper} from "global/style";

const MessageContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  width: 70%;
  float: right;
  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakSmall}) {
   margin-top: 24px;
  }
`;

const Bubble = styled.div`
  background: ${(props) => props.theme.themeColors[props.theme.activeTheme].userChatBubbleBackgroundColor};
  color: ${(props) => props.theme.themeColors[props.theme.activeTheme].userChatBubbleTextColor};
  // margin-top: 3px;
  word-break: break-word;
  font-style: normal;
  font-weight: normal;
  font-family: Lato;
  border-radius: 30px 0 30px 30px;
  font-size: 14px;
  line-height: 17px;
  padding: 14px 25px;
  text-align: left;
  padding-left:18px;
  padding-right:18px;
  line-break: nowrap;
  
  

  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakSmall}) {
    font-size: 16px;
    line-height: 21px;
  }

  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakLaptop}) {
    font-size: 24px;
    line-height: 29px;
    padding: 25.5px 41px;
    border-radius: 50px 0 50px 50px;
  }
`;


function Text({ data, send }) {
  return (
    <>
      {data.visible && (
        <MessageWrapper className="UserMessageWrapper">
          <MessageContainer className="UserMessageContainer">
            <BubbleWrapper className="BubbleWrapper bot-user-messages">
              <Bubble className="bubble">
                <span>{data.text}</span>
              </Bubble>
            </BubbleWrapper>
          </MessageContainer>
        </MessageWrapper>
      )}
    </>
  );
}

const actions = {
  send: chatActions.send,
};

const ConnectedPage = connect(null, actions)(Text);

export default ConnectedPage;
